/** API route map: URLS.Controller.AbaBankRouting */
export const AbaBankRouting = {
      Name: 'AbaBankingRouting/',
      GetAbaBankRouting: 'get-aba-bank-routing',
      AddAbaBankRouting: 'add-ababank-routing',
      UpdateAbaBankRouting: 'update-ababank-routing',
      DeleteAbaBankRouting: 'delete-ababank-routing',
};
